import { useContext } from 'react';

import JobSubscriptionContext from './JobSubscriptionContext';

const useJobSubscriptionContext = () => {
    const jobSubscriptionContextValue = useContext(JobSubscriptionContext);

    if (!jobSubscriptionContextValue) {
        throw new Error("Use 'JobSubscriptionContext' inside it's provider");
    }

    return jobSubscriptionContextValue;
};

export default useJobSubscriptionContext;
